<template>
    <div>
      <div class="withdraw-top">
        <img src="../../assets/images/bg_01.png" class="w-t-bg" />
        <div class="w-t-info">
            <p>我的可兑总分</p>
            <span>{{ user.account }}</span>
            <p class="w-t-12">推广收益于每月25日起开始提现，至30—31日提现到账</p>
        </div>
      </div>
      <div class="withdraw-detail">
          <h3 class="h3">总分分布明细</h3>
          <div class="withdraw-d-m">
            <div class="w-d-m-l">
              <span class="title">总分兑换<em>（满70.00可兑换）</em></span>
              <span class="price">{{ user.account }}</span>
            </div>
            <span class="w-d-m-btn" @click="applyWithdraw">申请兑换</span>
          </div>
      </div>

      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          value="className"
          :columns="columns"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
      <van-dialog v-model="show" title="申请提现" show-cancel-button :before-close="beforeClose">
        <van-field name="info.withdraw_type" label="提现类型">
          <template #input>
            <van-radio-group v-model="withdrawType" direction="horizontal">
              <!-- <van-radio name="0">到余额</van-radio> -->
              <van-radio name="1">到银行卡</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          readonly
          clickable
          name="picker"
          :value="info.members_accounts_text"
          label="收款账号"
          placeholder="请选择收款账号"
          @click="showPicker = true"
          v-show="withdrawType == 1"
        />
        <van-field
          v-model="info.price"
          name="金额"
          label="金额"
          type="number"
          placeholder="请输入金额"
          :rules="[{ required: true, message: '请填写金额' }]"
        />
        <van-field
          v-model="info.phone"
          type="tel"
          label="手机号"
          placeholder="请输入手机号"
          :rules="[{ required: true, message: '请填写手机号' }]"
        />
        <div class="service-price" v-show="withdrawType == 0">
          提现到余额后可以直接用于消费使用
        </div>
        <div class="service-price" v-show="withdrawType == 1">
          提现手续费率为：3%
        </div>
      </van-dialog>

      <Footer />
      <Floating />
      <wxNoShare />
    </div>
</template>

<script>
  import { Form, Dialog, Picker, Popup, RadioGroup, Radio } from 'vant';

  export default {
    components: {
      [Picker.name]: Picker,
      [Popup.name]: Popup,
      [Dialog.Component.name]: Dialog.Component,
      Form,
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio,
    },
    name: 'withdraw',
    data() {
      return {
        show: false,
        columns: [],
        showPicker: false,
        withdrawType: '1',
        user: [],
        info: {
          members_accounts_text: '',
          members_accounts_id: '',
          price: 0,
          withdraw_type: 0,
          phone: ''
        }
      }
    },
    created () {
      this.getUser()
    },
    methods: {
      getUser() {
        this.$api.get('user', null, r=>{
          this.user = r.data
          this.info.price = r.data.account
        })
        this.$api.get('account/index', null, r=>{
          r.data.map((item, index)=>{
            let name = item.name
            if(item.type === 1){
              item.subname = '微信'
            }else if(item.type === 2){
              item.subname = '支付宝'
            }else if(item.type === 3){
              item.subname = '银行卡'
            }
            item.text = '姓名：'+name+' / 账号：'+item.account_no
          })
          this.columns = r.data
        })
      },
      onConfirm(value) {
        this.info.members_accounts_text = value.text
        this.info.members_accounts_id = value.id
        this.showPicker = false
      },
      applyWithdraw() {
        if(this.user.withdraw_status == 0){
          this.$toast('未到可提现日期')
          return
        }else{
          this.withdrawType = '1'
          if(this.user.account >= 70){
            if(this.user.phone != '') {
              this.show = true
            }else{
              Dialog.confirm({
                title: '信息',
                message: '您的账号还未绑定手机号，请先绑定再提现！',
              })
                .then(() => {
                  this.$router.push({name:'binding', query:{type: 1}})
                })
                .catch(() => {
                  // on cancel
                });
            }
          }else{
            this.$toast('账户满70.00才可兑换')
            return
          }
        }
      },
      beforeClose : function (action, done) { // 点击事件 - 备注按钮提示框
        if (action === 'confirm') { // 确认
          this.info.withdraw_type = this.withdrawType
          if(this.columns.length == 0 && this.withdrawType == 1){
            Dialog.confirm({
              title: '信息',
              message: '您还未添加提现收款账号，请添加后再申请提现！',
            })
              .then(() => {
                this.$router.push({name:'accountList'})
              })
              .catch(() => {
                // on cancel
              });
            done(false)
            return
          }
          if(this.info.members_accounts_id == '' && this.withdrawType == '1'){
            this.$toast('请选择提现账户')
            done(false)
            return
          }
          if(this.info.price == ''){
            this.$toast('请输入提现金额')
            done(false)
            return
          }
          if(this.info.price > this.user.account){
            this.$toast('您输入金额不能大于可兑总分')
            done(false)
            return
          }
          if(this.info.phone == ''){
            this.$toast('请输入手机号')
            done(false)
            return
          }
          console.log(this.withdrawType);
          if(this.withdrawType == 0){
            Dialog.confirm({
            title: '信息',
            message: '您确定要提现到账户余额吗？！',
          }).then(() => {
              console.log(111);
              this.$api.post('users/withdraw', this.info, r=>{
                this.$toast(r.message)
                if(r.success === 1){
                  window.location.reload()
                  done();
                }else{
                  done(false)
                  return
                }
              })
            }).catch(() => {
              done(false)
              return
            });
          }else{
            this.$api.post('users/withdraw', this.info, r=>{
              this.$toast(r.message)
              if(r.success === 1){
                window.location.reload()
                done();
              }else{
                done(false)
                return
              }
            })
          }
        } else if (action === 'cancel') { // 取消
          done();
        }
      },
    }
  }
</script>

<style scoped>
  .withdraw-top{
    background: #ffffff;
    color:#f1e7ca;
    padding:15px;
    position: relative;
  }
  .withdraw-top .w-t-bg{
    width: 100%;
  }
  .withdraw-top .w-t-info{
    position: absolute;
    top: 20%;
    left: 10%;
  }
  .withdraw-top .w-t-info p{
    margin: 0;
    font-size: 14px;
    padding-bottom: 10px;
  }
  .withdraw-top .w-t-info .w-t-12{
    margin-top: 5px;
    font-size: 12px;
  }
  .withdraw-detail{
    padding:15px;
  }
  .withdraw-detail .h3{
    color: #343236;
    font-weight: normal;
    font-size: 15px;
    margin: 0;
  }
  .withdraw-d-m{
    background: #ffffff;
    padding:15px;
    margin-top: 10px;
    border-radius: 5px;
    overflow: hidden;
  }
  .withdraw-d-m .w-d-m-l{
    float: left;
    color:#343236;
  }
  .withdraw-d-m .w-d-m-l span{
    display: block;
  }
  .withdraw-d-m .w-d-m-l .title{
    font-size: 15px;
  }
  .withdraw-d-m .w-d-m-l .title em{
    font-style: normal;
    color:#969799;
  }
  .withdraw-d-m .w-d-m-l .price{
    margin-top: 5px;
  }
  .withdraw-d-m .w-d-m-btn{
    float: right;
    border:1px solid #969799;
    display: inline-block;
    padding: 5px 15px;
    border-radius: 20px;
    font-size: 14px;
    margin-top: 5px;
  }
  .service-price{
    font-size: 12px;
    padding:10px 15px;
    color:#323233;
  }
</style>



// WEBPACK FOOTER //
// src/views/index/withdraw.vue